import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikDatePicker } from 'src/components/shared/form/formik/FormikDatePicker'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { BankOnboardingFormValues } from 'src/interfaces/bankOnboarding'

const AttestorStepComponent = () => {
  return (
    <div css={tw`grid grid-cols-2 gap-4`}>
      <FormikTextField<BankOnboardingFormValues>
        name="attestorFirstName"
        label="First name *"
        placeholder="First name"
      />
      <FormikTextField<BankOnboardingFormValues>
        name="attestorLastName"
        label="Last name *"
        placeholder="Last name"
      />
      <FormikTextField<BankOnboardingFormValues>
        name="attestorJobTitle"
        label="Job title *"
        placeholder="Job title"
      />
      <FormikDatePicker<BankOnboardingFormValues>
        name="dateOfAttestation"
        label="Date of attestation *"
        fullWidth
        validateOnPick
      />
    </div>
  )
}

export const AttestorStep = memo(AttestorStepComponent)
